import { SignTypeValue } from "./esign.enums";

export const SIGNER_NAME_MIN_LENGTH = 2;
export const SIGNER_NAME_MAX_LENGTH = 100;
export const SIGNER_EMAIL_MAX_LENGTH = 254;
export const COORDINATE_MIN = 0;
export const COORDINATE_MAX = 10000;

export type ESignErrorState = {
  esignError: boolean;
  consentError: boolean;
  nameError: boolean;
  emailError: boolean;
  phoneError: boolean;
  contactEitherOrError: boolean;
  variableXError: boolean;
  variableYError: boolean;
};

export const defaultESignErrorState: ESignErrorState = {
  esignError: false,
  consentError: false,
  nameError: false,
  emailError: false,
  phoneError: false,
  contactEitherOrError: false,
  variableXError: false,
  variableYError: false,
};

export const signTypeBadgeMap: Record<
  SignTypeValue,
  { text: string; background: string; color: string }
> = {
  DIGITAL_ESIGN_EMAIL: {
    text: "Email",
    background: "#e8f3ff",
    color: "#1666b3",
  },
  DIGITAL_ESIGN_WHATSAPP: {
    text: "WhatsApp",
    background: "#e7ffe9",
    color: "#128c4b",
  },
  AADHAAR_ESIGN_OTP: {
    text: "Aadhaar OTP",
    background: "#fff6d9",
    color: "#b06500",
  },
};
